import { render, staticRenderFns } from "./ReportList.vue?vue&type=template&id=1be107c6"
import script from "./ReportList.js?vue&type=script&lang=js&external"
export * from "./ReportList.js?vue&type=script&lang=js&external"
import style0 from "./ReportList.vue?vue&type=style&index=0&id=1be107c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports